import { CharacterIcon } from '~/app/(default-layout)/s/[storyId]/_components/chat-script-render/op/character-icon';
import type { PostImage as PostImageOp } from '~/app/_types/chat-script';
import { Box, BoxProps, Flex, Paragraph, Image } from '@styled-system/jsx';

type Props = {
  op: PostImageOp;
} & BoxProps;

export const PostImage = ({ op, ...boxProps }: Props) => {
  const { character, image } = op;

  return (
    <Box position="relative" {...boxProps}>
      <Flex
        mr={character.position === 'right' ? '47px' : '15px'}
        ml={character.position === 'left' ? '47px' : '15px'}
        flexDir="column"
        alignItems={character.position === 'right' ? 'flex-end' : 'flex-start'}
      >
        <Paragraph
          fontSize="size_13"
          fontWeight="bold"
          mb="8px"
          color="primary"
          textShadow="0 0 4px rgba(0, 0, 0, 0.2)"
        >
          {character.name || '指定されてない'}
        </Paragraph>
        <Image alt="" src={image.imageUrl} borderRadius="10px" maxW="90%" />
      </Flex>
      <CharacterIcon
        src={character.thumbnailUrl}
        position="absolute"
        top="0"
        right={character.position === 'right' ? 0 : undefined}
        left={character.position === 'left' ? 0 : undefined}
      />
    </Box>
  );
};
